module.exports = __webpack_public_path__ + "img/ic_band_left_normal.e7c2540a.png";